document.addEventListener("DOMContentLoaded", () => {
    var thaiLineBtns = document.querySelectorAll("#line-th");
    var jpLineBtns = document.querySelectorAll("#line-jp");
    thaiLineBtns.forEach(thaiLineBtn => {
      thaiLineBtn.style.display = "none";
    });

    var domain = window.location.hostname;
    var domainThaiFlag = false;
    if (domain == "th.bonaventura.shop") {
        domainThaiFlag = true;
    }

    if (domainThaiFlag) {
      jpLineBtns.forEach(jpLineBtn => {
        jpLineBtn.style.display = "none";
      })
      thaiLineBtns.forEach(thaiLineBtn => {
        thaiLineBtn.style.display = "block";
      });
    }
});